import React, { Fragment, useEffect, useState } from 'react';
import { insuranceNetworkList } from '../utils/prop-types';
import { Pagination } from '@td/ui';
import InsuranceNetworkItem from '../components/Insurance-network-item';
import styles from '../styles.module.scss';

const ITEMS_COUNT_PER_PAGE = 10;

const InsuranceNetworkList = ({
                                roles,
                                currentInsuranceNetworks,
                                updateInsuranceNetwork,
                                deleteInsuranceNetwork,
                                selectedInsuranceNetwork,
                                setSelectedInsuranceNetwork,
                                searchValue,
                                setShowCreateForm
                              }) => {
  const [activePage, setActivePage] = useState(1);
  const [currentItems, setCurrentItems] = useState([]);

  useEffect(() => {
    const firstIndex = (activePage - 1) * ITEMS_COUNT_PER_PAGE;
    const lastIndex = firstIndex + ITEMS_COUNT_PER_PAGE;
    const newItems = currentInsuranceNetworks.slice(firstIndex, lastIndex);

    if (currentInsuranceNetworks.length > 0 && newItems.length === 0) {
      setActivePage(activePage - 1);
    } else {
      setCurrentItems(newItems);
      setSelectedInsuranceNetwork(null);
    }
  }, [activePage, currentInsuranceNetworks]);

  useEffect(() => {
    if (searchValue) {
      setActivePage(1);
    }
  }, [searchValue]);

  return (
    <Fragment>
      <h3 className={styles.tableTitle}>Insurance Networks</h3>
      {
        searchValue && currentItems.length === 0 ?
          <div className={styles.searchNotFound}>
            There were no Insurance Networks found with the given search criteria
          </div>
          :
          <Fragment>
            <table className={roles.canModify ? styles.tableCanModify : styles.tableCannotModify}>
              <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                {roles.canModify && <th>Action</th>}
              </tr>
              </thead>
              <tbody>
              {
                currentItems.map(insuranceNetwork =>
                  <InsuranceNetworkItem
                    key={`insurance-network-${insuranceNetwork.id}`}
                    roles={roles}
                    insuranceNetwork={insuranceNetwork}
                    updateInsuranceNetwork={updateInsuranceNetwork}
                    deleteInsuranceNetwork={deleteInsuranceNetwork}
                    setShowCreateForm={setShowCreateForm}
                    selectedInsuranceNetwork={selectedInsuranceNetwork}
                    setSelectedInsuranceNetwork={setSelectedInsuranceNetwork}
                  />
                )
              }
              </tbody>
            </table>
            <Pagination
              inline={false}
              activePage={activePage}
              itemsCountPerPage={ITEMS_COUNT_PER_PAGE}
              totalItemsCount={currentInsuranceNetworks.length}
              onChange={setActivePage}
            />
          </Fragment>
      }
    </Fragment>
  );
};

InsuranceNetworkList.propTypes = insuranceNetworkList;

export default InsuranceNetworkList;
